import { StateList } from '../pages/StateManager/StateList'

var urls = {
  dashboard: '/api/admin-service/dashboard',

  forgotPassword: '/api/admin-service/forget/password',

  cashBeadsTotalAmount: '/api/admin-service/transaction/cash-beads-totalAmount',

  resetAdminPassword: '/api/admin-service/reset/password',
  adminLogin: '/api/admin-service/auth/login',
  profileDetail: '/api/admin-service/auth/get-profile-details',
  updateProfile: '/api/admin-service/update-profile',
  updatePassword: '/api/admin-service/update-password',
  addRole: '/api/admin-service/role/add-role',
  roleList: '/api/admin-service/role/role-list',
  changeRoleStatus: '/api/admin-service/role/change/status',
  roleKeyValuePair: '/api/admin-service/role/role-key-value',
  rolePermissionUpdate: '/api/admin-service/set-permission',
  fetchPermission: '/api/admin-service/role-permission-details',

  addHelpCategory: '/api/admin-service/get-help-category/add',
  listHelpCategory: '/api/admin-service/get-help-category/list',

  packagesList: '/api/admin-service/packages/list',
  changePackageStatus: '/api/admin-service/packages/change/status',
  addPackage: '/api/admin-service/packages/create',

  getHelpList: '/api/admin-service/get-help/list',
  changeGetHelpStatus: '/api/admin-service/get-help/change/status',
  addGetHelp: '/api/admin-service/get-help/create',

  videoList: '/api/admin-service/video/list',
  videoCountByLanguage: '/api/admin-service/video/count',
  updateVideo: '/api/admin-service/video/update',
  activeInActiveVideo: '/api/admin-service/video/active-inactive',
  rewardOnVideo: '/api/admin-service/video/give-reward',
  rewardOnVideoNew: '/api/admin-service/video/give-reward-new',

  subAdminByRole: '/api/admin-service/subadmin/key-value-by-role',
  subAdminList: '/api/admin-service/subadmin/get/all/paged',
  subAdminAdd: '/api/admin-service/subadmin/create',
  subAdminChangeStatus: '/api/admin-service/subadmin/status',
  subAdminLogDetails: '/api/admin-service/subadmin/log-details',
  subAdminDelete: '/api/admin-service/subadmin/delete/by/id/',

  addFilter: '/api/admin-service/filter/add-filter',
  filterList: '/api/admin-service/filter/filter-list',
  changeFilterStatus: '/api/admin-service/filter/change/status',
  deleteFilter: '/api/admin-service/filter/delete/by/id',
  addNotification: '/api/admin-service/add/notification',
  notificationList: '/api/admin-service/notification-list',

  addEffect: '/api/admin-service/effects/add',
  effectList: '/api/admin-service/effects/effect-list',
  changeEffectStatus: '/api/admin-service/effects/change/status',
  getEffect: '/api/admin-service/effects/get/by',
  deleteEffect: '/api/admin-service/effects/delete/by/id',

  addFontStyle: '/api/admin-service/font-style/add',
  fontStyleList: '/api/admin-service/font-style/list',
  changeFontStyleStatus: '/api/admin-service/font-style/change/status',
  getFontStyle: '/api/admin-service/font-style/get/by',
  deleteFontStyle: '/api/admin-service/font-style/delete/by',

  addSound: '/api/admin-service/sounds/add',
  soundList: '/api/admin-service/sounds/sound-list',
  changeSoundStatus: '/api/admin-service/sounds/change/status',
  getSound: '/api/admin-service/sounds/get/by',
  deleteSound: '/api/admin-service/sounds/delete/by/id',

  reportAbuseList: '/api/admin-service/report-abuse/list',
  abuseReportList: '/api/admin-service/report-abuse/reporters-list',

  activeInActiveReport: '/api/admin-service/report-abuse/active-inactive',

  userList: '/api/admin-service/users/user-list',
  invitedUserList: '/api/admin-service/users/invited-users-list',
  userDetails: '/api/admin-service/users/user-by-id',
  /** Live Redis/feed diagnostics: GET .../users/{userId}/diagnostics?videoId= */
  userDiagnostics: '/api/admin-service/users',
  gradeList: '/api/admin-service/grades/grade-list',
  usersByGrade: '/api/admin-service/grades/usersByGrade',
  gradeChangeLogList: '/api/admin-service/grades/grade-change-log/list',
  userRecentTop3Videos: '/api/admin-service/video/recent-user-videos',
  userActiveInActive: '/api/admin-service/users/change/status',
  userCelebrityStatusChange: '/api/admin-service/users/celebrity/status',

  addWidget: '/api/admin-service/widget/add-widget',
  widgetList: '/api/admin-service/widget/widget-list',
  widgetKeyValuePair: '/api/admin-service/widget/key-value',
  changeWidgetStatus: '/api/admin-service/widget/change/status',
  getWidget: '/api/admin-service/widget/get/by',
  deleteWidget: '/api/admin-service/widget/delete/by/id',

  countryList: '/api/admin-service/country/country-list',
  addCountry: '/api/admin-service/country/add',
  importCountry: '/api/admin-service/country/import',
  changeCountryStatus: '/api/admin-service/country/change/status',
  countryCodeList: '/api/admin-service/country/country-code-list',

  stateList: '/api/admin-service/state/state-list',
  addState: '/api/admin-service/state/add',
  importState: '/api/admin-service/state/import',
  changeStateStatus: '/api/admin-service/state/change/status',
  stateCodeList: '/api/admin-service/state/state-key-value',
  stateCodeListByCountryId: '/api/admin-service/state/list-by-countryId',
  deleteState: '/api/admin-service/state/delete/by/id',

  getAllTypeOfMatrix: '/api/admin-service/globalAds/get-all-type',
  getAllTypeOfMatrixGlobalRate:
    '/api/admin-service/globalAds/get-config-global-matrix-rate',
  setMatrixGlobalWorldRate:
    '/api/admin-service/globalAds/set-config-global-matrix-rate',
  getConfigGLobalAdsMatrix:
    '/api/admin-service/globalAds/get-config-global-ads-matrix',
  configGlobalAdsMatrix:
    '/api/admin-service/globalAds/config-global-ads-matrix',
  adminUploadAds: '/api/admin-service/globalAds/admin-upload-ads',

  cityList: '/api/admin-service/city/city-list',
  addCity: '/api/admin-service/city/add',
  changeCityStatus: '/api/admin-service/city/change/status',
  cityCodeList: '/api/admin-service/city/state-key-value',
  cityCodeListByCountryId: '/api/admin-service/city/list-by-countryId',
  deleteCity: '/api/admin-service/city/delete/by/id',
  getCityCodeListByParent: '/api/admin-service/city/list-by-parentId',


  advertismentTypeList: '/api/admin-service/globalTypeOfAdvertisementMatrix/list',
  changeTypeStatus: '/api/admin-service/globalTypeOfAdvertisementMatrix/active-Inactive',
  addAdvertismentType: '/api/admin-service/globalTypeOfAdvertisementMatrix/create',

  districtList: '/api/admin-service/district/district-list',
  addDistrict: '/api/admin-service/district/add',
  importDistrict: '/api/admin-service/district/import',
  changeDistrictStatus: '/api/admin-service/district/change/status',
  districtCodeList: '/api/admin-service/district/district-key-value',
  deleteDistrict: '/api/admin-service/district/delete/by/id',
  getDistrictByStateId: '/api/admin-service/district/list-by-stateId',

  addTagInterest: '/api/admin-service/tags/add',
  tagInterestList: '/api/admin-service/tags/tag-list',
  tagInterestListKeyValuePair: '/api/admin-service/tags/interest-list',
  changeTagInterestStatus: '/api/admin-service/tags/change/status',

  addInfluencerCategory: '/api/admin-service/influencer-category/add',
  influencerCategoryList: '/api/admin-service/influencer-category/list',
  changeInfluencerCategoryStatus: '/api/admin-service/influencer-category/change/status',

  addLanguage: '/api/admin-service/language/add',
  languageList: '/api/admin-service/language/language-list',
  languageListKeyValuePair: '/api/admin-service/language/language-key-value',
  changeLanguageStatus: '/api/admin-service/language/change/status',
  deleteLanguage: '/api/admin-service/language/delete/by/id',

  addBanner: '/api/admin-service/banners/add',
  bannerList: '/api/admin-service/banners/banner-list',
  changeBannerStatus: '/api/admin-service/banners/change/status',

  addRewardInfo: '/api/admin-service/reward-info/add',
  rewardInfoList: '/api/admin-service/reward-info/list',
  changeRewardInfoStatus: '/api/admin-service/reward-info/change/status',


  addEvent: '/api/admin-service/event/create',
  eventList: '/api/admin-service/event/list',
  eventDetails: '/api/admin-service/event/getEvent',
  resultAnnounce: '/api/admin-service/event/result-announce',
  totalParticipantsList: '/api/admin-service/event/total-participants-list',
  setWinnerByAdmin: '/api/admin-service/event/winnerAnnouncementByAdmin',
  changeEventStatus: '/api/admin-service/event/active-Inactive',
  giveRewardToEventVideos: '/api/admin-service/event/winnerVideosSetByAdmin',


  addSticker: '/api/admin-service/stickers/add',
  stickerList: '/api/admin-service/stickers/list',
  meisheAssetsList: '/api/admin-service/meishe/list-admin',
  changeMeisheAssetsStatus: '/api/admin-service/meishe/status',
  deleteSticker: '/api/admin-service/stickers/delete/by/id',

  addFaq: '/api/admin-service/faqs/add',
  faqList: '/api/admin-service/faqs/faq-list',
  changeFaqStatus: '/api/admin-service/faqs/change/status',
  updateSequence: '/api/admin-service/faqs/update-seq',
  faqById: '/api/admin-service/faqs/get/by',

  uploadImage: '/api/admin-service/blogs/upload-image',
  addBlog: '/api/admin-service/blogs/add',
  blogList: '/api/admin-service/blogs/blog-list',
  changeBlogStatus: '/api/admin-service/blogs/change/status',

  addAds: '/api/admin-service/ads/add',
  adsList: '/api/admin-service/ads/ad-list',
  changeAdsStatus: '/api/admin-service/ads/change/status',
  changeInfluencerAdsStatus: '/api/admin-service/ads/influencer-change/status',
  deleteAds: '/api/admin-service/ads/delete/by/id',

  globalAdsList: '/api/admin-service/globalAds/admin-ads-list',

  influencerRequestList: '/api/admin-service/users/influencer/request-list',
  influencerRequestAcceptOrReject: '/api/admin-service/users/influencer/accept',

  userSearchDropdownList: '/api/admin-service/users/user-list-search',
  sendBatchPushNotification:
    '/api/admin-service/users/send-batch-push-notification-user',
  sendAdminWhatsApp: '/api/admin-service/users/send-admin-whatsapp',

  updateStaticContent: '/api/admin-service/contents/add',
  staticContentList: '/api/admin-service/contents/static-list',

  participantsRequestList: '/api/admin-service/special-reward/participants-list',
  clamRequestList: '/api/admin-service/special-reward/clam-request-list',
  clamRequestDetails: '/api/admin-service/special-reward/get-clam-request-details',
  markAsClam: '/api/admin-service/special-reward/mark-as-clammed',
  closeClamRequest: '/api/admin-service/special-reward/close-clam-request',
  changeParticipantRequestStatus: '/api/admin-service/special-reward/change-request-status',
  updateClamRequestStatus: '/api/admin-service/special-reward/clam-request-update-status',

  setGlobalSetting: '/api/admin-service/settings/add',
  getGlobalSetting: '/api/admin-service/settings/get-details',
  setAppVersionConfig: '/api/admin-service/settings/app-version-config',
  getAppVersionConfig: '/api/admin-service/settings/app-version-config',

  getTypeOfAdvertisement: '/api/admin-service/globalAds/typeOfAdvertisement',

  updateEmail: '/api/admin-service/email-template/add',
  emailList: '/api/admin-service/email-template/template-list',
  testAddUser: '/api/user-service/users/signup-complete',

  withdrawTransactioNList: '/api/admin-service/withdraw/transaction-list',
  totalWithdrawCommission:
    '/api/admin-service/withdraw/get-total-withdraw-commission',
  enableDisableMfaPayStack:
    '/api/admin-service/bank/enable-disable-otp-on-transaction',
  verifyMfaPayStackOtp: '/api/admin-service/bank/verify-disable-otp',
  paystackAvailableBalance: '/api/admin-service/bank/balance',
  approveDeclineTransaction: '/api/admin-service/withdraw/approve-denied',
  finalApproveTransactionVerification:
    '/api/admin-service/bank/final-approve-transaction',
  topUpUserWallet: '/api/admin-service/beads/top-up',

  purchaseBeadsList: '/api/admin-service/beads/purchase-history',
  liveManagerList: '/api/admin-service/live/list',
  // beadsTransactionHistory: '/api/admin-service/beads/transaction-history',
  beadsTransactionHistory: '/api/admin-service/transaction/history',
  amountTransactionHistory: '/api/admin-service/transaction/amount-history',
  addMeisheAssets: '/api/admin-service/meishe/add',
  updateMeisheAssets: '/api/admin-service/meishe/update',

  addPromoVideo: '/api/admin-service/promo/upload',
  listPromoVideo: '/api/admin-service/promo/list',
  changePromoVideoStatus: '/api/admin-service/promo/change/status',
  deletePromoVideo: '/api/admin-service/promo/delete/by',

  referralList: '/api/admin-service/shopping-logs/admin-list',
  distributionList: '/api/admin-service/shopping-logs/distributed-amount-list',
  transferCash: '/api/admin-service/shopping-logs/transfer-to-cash-wallet',


  changeAmount: "/api/admin-service/settings/update-shopping-amount",

  cashWithdrawHistory: '/api/admin-service/cash_withdraw_request/cash_withdraw_history',
  updateWithdrawStatus: '/api/admin-service/cash_withdraw_request/update/status',

  bankWithdrawHistory: '/api/admin-service/bank-withdraw/history-list',
  updateBankWithdrawStatus: '/api/admin-service/bank-withdraw/update/status',
  rejectBankWithdraw: '/api/admin-service/bank-withdraw/reject',
  updatePaymentProcessing: '/api/admin-service/bank-withdraw/update-payment-processing',
  uploadExcelFile: '/api/user-service/sftp/upload',
  // ranith 2025-12-06 - [Start] - [Process OUT Files Endpoint]
  processOutFiles: '/api/admin-service/bank-withdraw/bank/out/process',
  // ranith 2025-12-06 - [End] - [Process OUT Files Endpoint]



  userBeadsBalanceList: '/api/admin-service/beads/user-beads-balance-list',
  viewUserTransactions: '/api/admin-service/beads/view-user-transactions',

  userCashBalanceList: '/api/admin-service/cash/user-cash-balance-list',
  viewUserCashTransactions: '/api/admin-service/cash/view-user-transactions',

  shoppingDataList: '/api/admin-service/shopping-logs/shopping-data-list',


  topInviterEventList: '/api/admin-service/top-inviter-event/list',
  topInviterEventDetails: '/api/admin-service/top-inviter-event/details',
  topInviterEventParticipantsList: '/api/admin-service/top-inviter-event/participants-list',
  topInviterEventPayout: '/api/admin-service/top-inviter-event/payout',
  createTopInviterEvent: '/api/admin-service/top-inviter-event/create',
  updateTopInviterEvent: '/api/admin-service/top-inviter-event/update-event',
  userLocationAnalytics: '/api/admin-service/users/user-location-analytics',

  // Analytics APIs
  analyticsDau: '/api/admin-service/analytics/dau',
  analyticsPeak: '/api/admin-service/analytics/peak',
  analyticsLocation: '/api/admin-service/analytics/location',
  analyticsToday: '/api/admin-service/analytics/today',
  userActivityAdminList: '/api/admin-service/analytics/user-activity-admin/list',
  paymentsSummary: '/api/admin-service/beads/admin/payments-data'
}
export default urls
